/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EAddressType } from "../types/EAddressType.ts";

/**
 * @description 1 = Personal | 2 = Commercial | 3 = Payment |
 */
export const eAddressTypeSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3)])
  .describe(
    "1 = Personal | 2 = Commercial | 3 = Payment | ",
  ) as unknown as ToZod<EAddressType>;
